// Components
import Header from './global/header/header';
import IsiTray from './global/isi-tray';
import HcpModal from './modals/hcp-modal';
import LeavingSiteModal from './modals/leaving-site-modal';
import AxogenSiteModal from './modals/axogen-site-modal';
import VideoModal from './modals/video-modal';
import Accordion from './components/accordion';
import PrivacyPolicyTable from './components/privacy-policy-table';
import SurgeonLocator from './fragments/surgeon-locator/surgeon-locator';

Header.init();
IsiTray.init();
HcpModal.init();
LeavingSiteModal.setupExternalLinks();
AxogenSiteModal.setupExternalLinks();
Accordion.init();
PrivacyPolicyTable.init();
SurgeonLocator.init();

// Do this after any DOM modifications may have been made
VideoModal.setupVideoPlayButtons();

// Set up anchors to scroll such that the sticky header won't obscure the target content
const setupAnchorLinks = (anchorId) => {
    const anchorLinks = document.querySelectorAll(`a[href = "#${anchorId}"`);
    if (anchorLinks.length <= 0) {
        return;
    }

    const scrollTarget = document.getElementById(anchorId);
    if (!scrollTarget) {
        return;
    }

    const clickCallback = (event) => {
        event.preventDefault();

        // Close the mobile hamburger menu, if open
        Header.current.closeMenu(false, event.shiftKey);

        // Scroll to the target content
        const bounds = scrollTarget.getBoundingClientRect();
        window.scrollTo({
            left: 0,
            top: (bounds.top + window.pageYOffset) - Header.height,
            behavior: 'smooth',
        });
    };

    for (const anchorLink of anchorLinks) {
        anchorLink.addEventListener('click', clickCallback);
    }
};

// setupAnchorLinks('primary');
setupAnchorLinks('isi');
// const anchors = document.getElementsByClassName('anchor');
// for (const anchor of anchors) {
//     setupAnchorLinks(anchor.id);
// }

// Remove the "preload" class from any elements it's applied to
document.addEventListener('DOMContentLoaded', () => {
    const preloadElements = document.getElementsByClassName('preload');
    for (const element of preloadElements) {
        element.classList.remove('preload');
    }
});
